import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { firebase } from '../../core/services'

import {
  ANALYTICS_EVENT_CATEGORIES,
  ANALYTICS_EVENTS,
} from '../../common/constants'
import { apolloService } from '../../common/services'

import { RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION_MUTATION } from '../graphql/mutations'
import { RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION } from '../redux/action-types'

const useRetryMenuCurationTaskAutomaticCurationMutation = () => {
  const dispatch = useDispatch()

  const { isUpdateLoading: isLoading, updateError: error } = useSelector(
    store => store.menuCurationTasks.menuCurationTask,
  )

  const mutate = useCallback(
    id => {
      firebase.logEvent(
        ANALYTICS_EVENTS.MENU_CURATOR_UPDATE_MENU_TASK
          .MENU_CURATOR_RETRY_CURATION,
        {
          menuCurationTaskId: id,
          eventCategory:
            ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_UPDATE_MENU_TASK,
        },
      )

      return apolloService.mutate({
        mutation: RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION_MUTATION,
        variables: { id },
        dispatch,
        action: RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION,
      })
    },
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useRetryMenuCurationTaskAutomaticCurationMutation
